<script setup lang="ts">
import type { PropType } from 'vue'
import type { SimulationPoolConnector } from '../../../../interfaces/simulation'
import type { UserVehicle } from '../../../../interfaces/vehicle'
import VehicleCell from './VehicleCell.vue'
import ConnectorCellPicker from './ConnectorCellPicker.vue'
import { FormInputType } from '../../../../interfaces/input'

defineProps({
    vehicle: {
        type: Object as PropType<UserVehicle>,
        required: true
    },
    connector: {
        type: Object as PropType<SimulationPoolConnector>,
        required: true
    },
    legacyApiUrl: {
        type: String,
        required: true
    },
    hasTimeInput: {
        type: Boolean,
        default: false
    }
})

defineEmits<{
    selectVehicle: [versionId: number]
    selectConnector: [connector: SimulationPoolConnector]
}>()

const timeValue = defineModel<string>({
    default: ''
})
</script>

<template>
    <div class="flex flex-col rounded-lg border border-gray-disabled">
        <VehicleCell :vehicle @selectVehicle="$emit('selectVehicle', $event)" />
        <div class="ml-4 md:ml-0 h-px border-b border-gray-disabled" />
        <ConnectorCellPicker
            :connector
            :legacyApiUrl
            @selectConnector="
                ($event: SimulationPoolConnector) =>
                    $emit('selectConnector', $event)
            "
        />
        <div v-if="hasTimeInput" class="flex flex-col w-full">
            <div class="ml-4 h-px border-b border-gray-disabled" />
            <ChargemapFormInput
                v-model="timeValue"
                :type="FormInputType.TIME"
                :label="$t('simulation.charge.user_settings.time')"
            >
                <IconClock class="size-5" />
            </ChargemapFormInput>
        </div>
    </div>
</template>
